// frontend/shared-ui/src/components/ImageUploader.jsx
import React from "react";
import FileUploader from "./FileUploader";

export default function ImageUploader({
  onFiles,
  multiple = true,
  maxFiles = 10,
  maxSizeMB = 10,
  disabled = false,
}) {
  return (
    <FileUploader
      accept="image/*"
      multiple={multiple}
      maxFiles={maxFiles}
      maxSizeMB={maxSizeMB}
      onFiles={onFiles}
      label={multiple ? "Choose images" : "Choose image"}
      dragLabel="Drag & drop images or click to browse"
      disabled={disabled}
    />
  );
}
